import { useState, useEffect } from 'react';
import axios from '@helpers/axios';
import { TeamTrackInfo } from './hookTypes';

const useTeamTrackInfo = (teamId: string) => {
  const [teamInfo, setTeamInfo] = useState<TeamTrackInfo | null>(null);
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    if (!teamId) {
      return;
    }

    const fetchTeamTrackInfo = async () => {
      setLoading(true);
      setError(null);

      try {
        const response = await axios.get(`/v2/teams/${teamId}/tracker`);
        setTeamInfo(response.data);
      } catch (err) {
        setError(err?.data?.message || 'Failed to fetch team track info');
      } finally {
        setLoading(false);
      }
    };

    fetchTeamTrackInfo();
  }, [teamId]);

  return { teamInfo, loading, error };
};

export default useTeamTrackInfo;
